const Header = (props) => {
    return (
        <div className="header">
        <header style={{height: "480px", overflow: 'hidden'}}>
            <img style={{width:"100%"}} alt="plate of food" src="https://images.unsplash.com/photo-1505935428862-770b6f24f629?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2334&q=80"/>
        </header>
        </div>
    )
  }
  


  export default Header